export const pageBackgroundColor = '#FFFFFF'
export const textColor = '#1E1E1E'
export const textInvertedColor = '#FFFFFF'
export const highlightColor = '#FA4616'
export const backgroundColor = '#F6F6F6'
export const metaColor = '#f6e305'
export const errorColor = '#e03e07'
export const darkRed = '#c22f03'
